<template>
  <ModalWrapper :model-name="modelName">
    <div class="modal-select-type">
      <div class="modal-select-type_wrapper-filters">
        <p class="modal-select-type_wrapper-filters-title">
          Select type of <span>images</span>
        </p>

        <div class="modal-select-type_wrapper-filters-list">
          <template v-for="image in cards" :key="image.id">
            <div
              class="modal-select-type_wrapper-filters-item"
              :class="{
                'inactive': !image.isActive,
                'selected': image.selected
              }"
              @click="handleFilter(image)"
              @touchstart="handleFilter(image)"
            >
              <div class="image-holder">
                <img
                  :src="image.img"
                  alt="single generation content"
                >
              </div>
              <p>{{ image.title }}</p>
            </div>
          </template>
        </div>
        <Button
          class="modal-select-type_wrapper-info_button"
          @click="handleGenerate('singleRequest')"
          text="Create your first FREE Image"
        />
      </div>
    </div>
  </ModalWrapper>
</template>
<script>
import ModalWrapper from "@/components/modals/ModalWrapper.vue";
import Button from "@/components/Button.vue";

export default {
  name: "SelectType",
  components: {
    Button,
    ModalWrapper,
  },
  props: {
    modelName: String,
    cards: {
      type: Array
    }
  },
  setup (_, { emit }) {
    const handleFilter = (image) => {
      emit('handleFilter', image)
    }
    const handleGenerate = (filter) => {
      emit('handleGenerate', filter)
    }

    return {
      handleFilter,
      handleGenerate
    }
  }
}
</script>

<style lang="scss">
.modal-select-type {
  background-color: rgb(22, 22, 22);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  margin: 20px auto;
  padding: 20px 30px;
  border-radius: 15px;
  width: 700px;
  overflow: auto;
  @media screen and (max-width: 775px) {
    width: 90%;
    // height: 460px;
  }
  @media screen and (max-height: 667px) {
     height: 90vh;
  }

  &_wrapper {
    &-filters {
      position: relative;
      width: 100%;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      max-width: 90%;
      margin: 0 auto;

      @media screen and (max-width: 550px) {
        width: 100% !important;
      }

      &-title {
        color: #FFF;
        text-align: center;
        font-size: 36px;
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        text-transform: capitalize;

        @media screen and (max-width: 768px) {
          font-size: 28px;
        }

        @media screen and (max-width: 550px) {
          font-size: 24px;
        }

        span {
          color: #b4f12f;
        }
      }

      &-list {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        width: 100%;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      &-line {
        height: 100%;
        width: 1px;
        background: #ACF601;
      }

      &-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: calc(50% - 10px);
        cursor: pointer;

        &.inactive {
          .image-holder {
            position: relative;

            &::before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-image: url(../../assets/img/stripes.png);
              background-size: 100% 100%;
              background-repeat: no-repeat;
              background-position: center;
              z-index: 1;
            }
          }
        }

        &.selected {
          .image-holder {
            border: 3px solid #ACF601;
          }
        }

        .image-holder {
          border-radius: 20px;
          background: #FFF;
          width: 100%;
          height: 360px;
          margin-bottom: 6px;
          overflow: hidden;

          @media screen and (min-width: 1024px) {
            &:hover {
              border: 3px solid #ACF601;
            }
          }

          @media screen and (max-width: 1024px) {
            height: 240px;
          }
          @media screen and (max-width: 768px) {
            height: 220px;
          }

          @media screen and (max-width: 550px) {
            height: 150px;
          }
          @media screen and (max-width: 375px) {
            height: 130px;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }

        p {
          color: #FFF;
          text-align: center;
          font-size: 32px;
          font-style: normal;
          font-weight: 700;
          line-height: 100%;
          text-transform: capitalize;

          @media screen and (max-width: 768px) {
            font-size: 20px;
          }

          @media screen and (max-width: 550px) {
            font-size: 16px;
          }
        }
      }
    }
    &-info_button {
      .btn-holder_item {
        @media screen and (max-width: 550px) {
          padding: 10px 14px;
        }
        @media screen and (max-width: 375px) {
          font-size: 14px;
        }
      }
    }
  }
}

</style>
